import {
    omit as _omit,
} from '@lodash';
import Vue from 'vue';
import { Subscription } from 'rxjs';
import Struct from '@core/models/struct/Struct';
import Match from '@core/models/offer/Match';
import StoreUtil from '@store/StoreUtil';
import { ISportOfferState } from './index';
import * as types from './mutationTypes';
import { mergeMatch, promoteSpecialTournamentToCategory } from './helpers';
import deepFreeze from '@core/utils/dataTransformation/deepFreeze';
import { ISuperOfferCollections } from './types';
import MarketGroupInfo from '@models/struct/MarketGroupInfo';
import OfferService from '@core/services/offer/OfferService';
// import { logSocketEvent, logSocketRawEvent } from '@utils/network/NetworkUtils';

export default {
    [types.SET_STRUCT](state: ISportOfferState, struct: Struct) {
        state.sports = struct.sports;
        state.categories = struct.categories;
        state.tournaments = struct.tournaments;
        state.markets = struct.markets;
        state.oddTypes = struct.oddTypes;
        state.marketGroupInfos = struct.marketGroupInfos;
        state.superOfferConfig = struct.superOffer;
        state.isStructFetched = true;
    },
    [types.SET_MARKET_GROUP_INFOS](state: ISportOfferState, marketGroupInfos: Record<number, MarketGroupInfo>): void {
        state.marketGroupInfos = marketGroupInfos;
    },
    [types.SET_EVENTS](state: ISportOfferState, events: Match[]) {
        const sseEnabled = OfferService.getInstance().sseEnabled();

        events.forEach((event) => {
            promoteSpecialTournamentToCategory(event, state.specialTournaments);
            freezeOdds(event);
            if (state.events[event.id]) {
                // logSocketEvent('setEventsMutationsInStore', event);
                Vue.set(
                    state.events,
                    event.id.toString(),
                    // mergeMatch freezes object!
                    mergeMatch(
                        state.events[event.id],
                        event,
                        sseEnabled,
                    )
                );
            } else {
                // logSocketEvent('setEventsMutationsNotInStore', event);
                Vue.set(
                    state.events,
                    event.id.toString(),
                    Object.freeze(event)
                );
            }
        });
    },
    [types.SET_EVENT](state: ISportOfferState, event: Match) {
        promoteSpecialTournamentToCategory(event, state.specialTournaments);
        freezeOdds(event);
        const sseEnabled = OfferService.getInstance().sseEnabled();
        if (state.events[event.id]) {
            Vue.set(
                state.events,
                event.id.toString(),
                mergeMatch(
                    state.events[event.id],
                    event,
                    sseEnabled,
                )
            );
        } else {
            Vue.set(
                state.events,
                event.id.toString(),
                event,
            );
        }
    },
    [types.INCREMENT_ALL_CHANGES_ID](state: ISportOfferState) {
        state.allChangesIncrementId = (state.allChangesIncrementId + 1) % 2;
    },
    [types.REMOVE_EVENTS](state: ISportOfferState, events: Match[]) {
        events.forEach((event) => Vue.delete(state.events, event.id.toString()));
    },
    [types.REMOVE_EVENT](state: ISportOfferState, eventId: number) {
        Vue.delete(state.events, eventId.toString());
    },
    [types.SET_TOP_TEN_EVENTS](state: ISportOfferState, eventsIds: number[]) {
        state.topTenEvents = eventsIds;
    },
    [types.SET_TOP_TEN_EVENT](state: ISportOfferState, eventId: number) {
        state.topTenEvents.push(eventId);
    },
    [types.SET_PROMOTIONAL_EVENTS](state: ISportOfferState, promotionalEvents: ISuperOfferCollections) {
        state.promotionalEvents = promotionalEvents;
    },
    [types.SET_EVENT_SUBSCRIPTION](
        state: ISportOfferState, payload: { eventId: number; subscription: Subscription }
    ) {
        state.subscriptions = { ...state.subscriptions, [payload.eventId]: payload.subscription };
    },
    [types.REMOVE_EVENT_SUBSCRIPTION](state: ISportOfferState, eventId: number) {
        state.subscriptions = _omit(state.subscriptions, [eventId]);
    },
    [types.UPDATE_EVENT](state: ISportOfferState, event: Match) {
        promoteSpecialTournamentToCategory(event, state.specialTournaments);
        freezeOdds(event);
        if (state.events[event.id]) {
            state.events[event.id] = mergeMatch(
                state.events[event.id],
                event
            ) as Match;
        }
    },
    [types.SET_IS_OFFER_STARTING]: StoreUtil.createSimpleMutator('isOfferStarting'),
    [types.SET_IS_OFFER_READY]: StoreUtil.createSimpleMutator('isOfferReady'),
    [types.SET_SHOULD_FETCH_OFFER]: StoreUtil.createSimpleMutator('shouldFetchOffer'),
    [types.SET_SPECIAL_TOURNAMENTS]: StoreUtil.createSimpleMutator('specialTournaments'),
    [types.SET_BROADCASTS]: StoreUtil.createSimpleMutator('broadcasts'),
    [types.SET_LIVE_EVENTS_COUNT]: StoreUtil.createSimpleMutator('liveEventsCount'),
    [types.SET_ARE_SUBSCRIPTIONS_SET]: StoreUtil.createSimpleMutator('areSubscriptionsSet'),
    [types.SET_IS_OFFER_FETCHED]: StoreUtil.createSimpleMutator('isOfferFetched'),
    [types.SET_IS_SUPER_OFFER_FETCHED]: StoreUtil.createSimpleMutator('isSuperOfferFetched'),
    [types.SET_ARE_TOP_TEN_EVENTS_FETCHED]: StoreUtil.createSimpleMutator('areTopTenEventsFetched'),
    [types.SET_ODD_VALUE_DYNAMICS]: StoreUtil.createSimpleMutator('oddValueDynamics'),
    [types.SET_EXPANDED_MARKET_IDS]: StoreUtil.createSimpleMutator('expandedMarketIds'),
    [types.TOGGLE_EXPANDED_MARKET_ID]: StoreUtil.createSetMutator('expandedMarketIds'),
};

function freezeOdds(match: Match) {
    match.setOdds(match.getOdds().map((odd) => Object.freeze(odd)));
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/data/sportOffer/mutations.ts